import React, {Fragment, PureComponent} from 'react';
import PropTypes from 'prop-types';
import ParagraphLeftAlign from "../../../../../shared/components/Styled/ParagraphLeftAlign.jsx";
import PrimaryButton from "../../../../../shared/components/Styled/Buttons/PrimaryButton.jsx";
import SecondaryButton from "../../../../../shared/components/Styled/Buttons/SecondaryButton.jsx";
import {Col, Row} from "reactstrap";
import H6TitleLeftAlign from "../../../../../shared/components/Styled/H6TitleLeftAlign.jsx";
import {
  CREATE_FREELANCE_STEPS,
  updateCreatFreelanceStep
} from "../../../../../shared/containers/Freelance/setNextStep.js";
import FreelanceAgent from "../../../../components/Agent/FreelanceAgent.jsx";
import H5TitleLeftAlign from "../../../../../shared/components/Styled/H5TitleLeftAlign.jsx";

class Introduction extends PureComponent {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    freelance: PropTypes.object.isRequired,
    submit: PropTypes.func.isRequired,
    nextPage: PropTypes.func.isRequired,
  };

  goToStep = (step) => {
    updateCreatFreelanceStep(
      this.props.freelance.id,
      step,
      () => this.props.submit({
        freelance: {
          ...this.props.freelance
        },
        silentMode: true,
      })
    )
  }

  render() {
    const {freelance} = this.props;

    return (
      <Fragment>
        <H5TitleLeftAlign title="Expériences professionnelles"/>

        <Row>
          <Col xs={12} className={"pt-1"}>
            <ParagraphLeftAlign className="mb-4">
          C'est {' '}<strong>la dernière étape pour valider votre profil ! </strong>{' '}
          Comme nous l'avons vu ensemble lors de notre entretien, vous n'avez plus qu'à renseigner vos différentes expériences professionnelles.
            </ParagraphLeftAlign>
          </Col>

        </Row>

        <H6TitleLeftAlign title={"Cet exercice peut être un peu fastidieux mais reste primordial dans notre fonctionnement."} />

        <ParagraphLeftAlign>
          Pour rappel cela permet :
        </ParagraphLeftAlign>
        <ul className={"mb-4"}>
          <li>De faire {' '}<strong>apparaitre votre profil </strong>{' '} dans nos résultats de recherche</li>
          <li>D'<strong>être visible</strong>{' '} par nos clients</li>
          <li>De vous {' '}<strong>préparer pour les entretiens</strong></li>
        </ul>

        <H6TitleLeftAlign title={"DÉTAILLEZ"} />
        <ParagraphLeftAlign className="mb-4">
          Il est important que vous soyez
          {' '}<strong>le plus exhaustif possible</strong>, surtout{' '}<strong>concernant les expériences les plus récentes.</strong>{' '}
          Car notre plateforme fonctionne avec son propre moteur de recherche (cf google) :
          {' '}<strong>plus vos informations sont détaillées, plus votre classement pour une recherche donnée sera efficace</strong>.
        </ParagraphLeftAlign>

        <H6TitleLeftAlign title={"ADAPTEZ"} />
        <ParagraphLeftAlign className="mb-4">
          Evidemment, vous pouvez tout à fait vous éloigner du modèle {' '}<strong>si cela reste raisonnable.</strong>{' '}
          Certaines expériences peuvent être mieux exprimées sur un autre modèle, mais il en reste
          {' '}<strong>structurer les expériences est indispensable </strong>{' '} (bullet points, sectionsdes expériences, ...).
        </ParagraphLeftAlign>

        <H6TitleLeftAlign title={"NE PERDEZ PAS DE TEMPS"} />
        <ParagraphLeftAlign className="mb-4">
          Des expériences anciennes peuvent être beaucoup moins étoffées que les plus récentes (avant 2010). Pensez {' '}<strong>mot clefs</strong>{' '}
          et résumez en quelques phrases ces expériences.
        </ParagraphLeftAlign>

        <Row>
          <Col xs={12}>
            {freelance.agent && freelance.agent.id &&
              <div className="my-2">
                <FreelanceAgent agentId={freelance.agent.id}/>
              </div>
            }
          </Col>
        </Row>

        <Row className={"justify-space-between"}>
          <Col className={'text-center'}>
            <SecondaryButton className="ml-auto ml-sm-0 mr-auto mt-2" onClick={() => this.goToStep(CREATE_FREELANCE_STEPS.PRESENTATION)}> Etape précédente </SecondaryButton>
          </Col>
          <Col className={"text-center"}>
            <PrimaryButton className="ml-auto mr-auto mr-sm-0 mt-2" onClick={this.props.nextPage}>
              Renseigner mes missions
            </PrimaryButton>
          </Col>
        </Row>
      </Fragment>
    )
  }
}

export default Introduction;
